import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'displayImage'
})
export class DisplayImagePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(imageAsBase64: string): SafeResourceUrl {
    return imageAsBase64
      ? this._sanitizer.bypassSecurityTrustResourceUrl(
          `data:image/jpg;base64, ${imageAsBase64}`
        )
      : null;
  }
}
